module.exports = __webpack_public_path__ + "static/vishal-bhalla-200w-103018-3707fd710b9e043e394d24295de80acb.jpg";